var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPause20 = function SvgIconPause20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M7.167 3.023a4.148 4.148 0 0 0-4.144 4.144v41.666a4.148 4.148 0 0 0 4.144 4.143h41.666a4.148 4.148 0 0 0 4.144-4.143V7.167a4.148 4.148 0 0 0-4.144-4.144H7.167zM48.833 56H7.167A7.175 7.175 0 0 1 0 48.833V7.167A7.174 7.174 0 0 1 7.167 0h41.666A7.174 7.174 0 0 1 56 7.167v41.666A7.175 7.175 0 0 1 48.833 56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999DC8",
    d: "M22 34h5V21h-5zm7 0h5V21h-5z"
  }))));
};
export default SvgIconPause20;